import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { currentCart, productAtom } from "../atoms/auth";
import { auth } from "../functions/firebase";

export default function ProductViewItem({ setLoading, check, optionsTotal }) {

    const navigate = useNavigate()
    const product = useRecoilValue(productAtom)
    const setCart = useSetRecoilState(currentCart)
    
    const options_keys = ["options", "options1", "options2", "options3", "options4", "options5"]



    return (
        <div id="checkoutButton" className="row centerX spaceBetween">
            <div>
                <h1 style={{ fontSize: 30, color: localStorage.getItem("theme") === "light" ? "#000" : "#fff" }}>R {((Number(product.price) * product.quantity) + optionsTotal).toFixed(2)}</h1>
            </div>
            <div className="buttons" style={{ width: "50%" }}>
                <button style={{ backgroundColor: "var(--primary)", width: "100%", whiteSpace: "nowrap", marginBottom: 0, color: "#000" }}
                    onClick={async () => {

                        for await (const option of options_keys) {
                            if(product[option + "Required"] && check[option].length === 0) {
                                return alert(product[option + "Label"])
                            }
                        }

                        setCart(c => ([ ...c, { ...product, ...check, itemTotal: (Number(product.price) * product.quantity) + optionsTotal, optionsTotal }]))
                        setLoading(true)
                        setTimeout(() => {
                            setLoading(false)
                            navigate(`/auth-1/${auth?.currentUser?.uid}/cart`)
                        }, 1000)
                    }}
                >Add To Cart</button>
            </div>
        </div>
    )
}